import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

export interface PageHeaderProps {
  /** Główny tytuł strony. */
  title: ReactNode;
  subtitle?: ReactNode;
  /** Ikona w kwadratowym tile obok tytułu. */
  icon?: LucideIcon;
  /** Akcje po prawej (buttony, dropdowny). */
  actions?: ReactNode;
  className?: string;
}

/**
 * Standardowy nagłówek strony. Kanoniczny wzorzec "ikona + tytuł + subtitle"
 * obowiązuje wszędzie na aplikacji (decyzja user 2026-04-22 — usunięto
 * warianty bez ikony / z accentWord gradient / z actions, zbyt dużo stylów).
 * Actions pozostają jako prop dla nielicznych uzasadnionych przypadków
 * (np. "Nowa wiadomość" w Inboxie).
 */
export function PageHeader({
  title,
  subtitle,
  icon: Icon,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div className={['flex items-center justify-between gap-4 mb-6', className].filter(Boolean).join(' ')}>
      <div className="flex items-center gap-4 min-w-0 flex-1">
        {Icon && (
          <div className="shrink-0 w-16 h-16 rounded-xl bg-gradient-to-br from-accent-primary/20 to-accent-secondary/20 border border-accent-primary/30 flex items-center justify-center">
            <Icon className="w-7 h-7 text-accent-primary" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <h1 className="text-3xl font-bold text-text-primary leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1.5 text-sm text-text-muted leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {actions && (
        <div className="shrink-0 flex items-center gap-2">{actions}</div>
      )}
    </div>
  );
}
